const PROJECTCODE_GETALL_SUBMIT = 'PROJECTCODE_GETALL_SUBMIT';
const PROJECTCODE_GETALL_SUBMIT_REQUESTED = 'PROJECTCODE_GETALL_SUBMIT_REQUESTED';
const PROJECTCODE_GETALL_SUBMIT_SUCCEEDED = 'PROJECTCODE_GETALL_SUBMIT_SUCCEEDED';
const PROJECTCODE_GETALL_SUBMIT_FAILED = 'PROJECTCODE_GETALL_SUBMIT_FAILED';

export { PROJECTCODE_GETALL_SUBMIT };
export { PROJECTCODE_GETALL_SUBMIT_REQUESTED };
export { PROJECTCODE_GETALL_SUBMIT_SUCCEEDED };
export { PROJECTCODE_GETALL_SUBMIT_FAILED };
